"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventHandlerCancelledEventArgs = void 0;
const EventType_1 = require("../EventType");
class EventHandlerCancelledEventArgs {
    constructor(eventHandlerId) {
        this.eventHandlerId = eventHandlerId;
        this.__type = EventType_1.EventType.EventHandlerCancelled;
        this.__typeName = "EventHandlerCancelled";
    }
}
exports.EventHandlerCancelledEventArgs = EventHandlerCancelledEventArgs;
